/**
 * Assessment API Service
 */

import apiClient from './apiClient';
import {
  AssessmentDTO,
  CreateAssessmentRequest,
  AssessmentType,
  AssessmentStatus,
  PageResponse,
} from '../types/assessment.types';

const BASE_PATH = '/v1/assessments';

class AssessmentService {
  async createAssessment(request: CreateAssessmentRequest): Promise<AssessmentDTO> {
    const response = await apiClient.post<AssessmentDTO>(BASE_PATH, request);
    return response.data;
  }

  async getAssessmentById(id: string): Promise<AssessmentDTO> {
    const response = await apiClient.get<AssessmentDTO>(`${BASE_PATH}/${id}`);
    return response.data;
  }

  async getAllAssessments(page: number = 0, size: number = 20): Promise<PageResponse<AssessmentDTO>> {
    const response = await apiClient.get<PageResponse<AssessmentDTO>>(BASE_PATH, {
      params: { page, size },
    });
    return response.data;
  }

  async getAssessmentsByResident(residentId: string): Promise<AssessmentDTO[]> {
    const response = await apiClient.get<AssessmentDTO[]>(`${BASE_PATH}/resident/${residentId}`);
    return response.data;
  }

  async getAssessmentsByType(assessmentType: AssessmentType): Promise<AssessmentDTO[]> {
    const response = await apiClient.get<AssessmentDTO[]>(`${BASE_PATH}/type/${assessmentType}`);
    return response.data;
  }

  async getAssessmentsByStatus(status: AssessmentStatus): Promise<AssessmentDTO[]> {
    const response = await apiClient.get<AssessmentDTO[]>(`${BASE_PATH}/status/${status}`);
    return response.data;
  }

  async updateAssessment(id: string, data: Partial<AssessmentDTO>): Promise<AssessmentDTO> {
    const response = await apiClient.put<AssessmentDTO>(`${BASE_PATH}/${id}`, data);
    return response.data;
  }

  async submitAssessment(id: string): Promise<AssessmentDTO> {
    const response = await apiClient.post<AssessmentDTO>(`${BASE_PATH}/${id}/submit`);
    return response.data;
  }

  async approveAssessment(id: string): Promise<AssessmentDTO> {
    const response = await apiClient.post<AssessmentDTO>(`${BASE_PATH}/${id}/approve`);
    return response.data;
  }

  async deleteAssessment(id: string): Promise<void> {
    await apiClient.delete(`${BASE_PATH}/${id}`);
  }
}

export default new AssessmentService();
